var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextpreset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: 1550855984
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.203125 0 L 365.453125 0 L 365.453125 375 L 9.203125 375 Z M 9.203125 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1550855984)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.316406 0 L 9.316406 85.21875 L 31.367188 85.21875 C 43.921875 42.125 71.058594 14.140625 128.464844 14.140625 L 157.914062 14.140625 L 157.914062 360.410156 L 128.015625 360.410156 L 128.015625 375 L 246.644531 375 L 246.644531 360.410156 L 216.742188 360.410156 L 216.742188 14.140625 L 246.195312 14.140625 C 303.675781 14.140625 330.808594 42.125 343.292969 85.21875 L 365.34375 85.21875 L 365.34375 0 Z M 9.316406 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextpreset);
export default __webpack_public_path__ + "static/media/Text preset.0ca1a208d4494e603806dc4644e1d0dc.svg";
export { ForwardRef as ReactComponent };